// 搜尋的 site: 語法（SRCH-01）：`site:台北店`、`site:"台北 一店",新竹店`、`site:site-01…`。
// 伺服器的全文索引沒有場域欄，這裡在送出前換成「那些場域（含子場域）底下的家戶」——搜尋 API 的 homes 範圍。
// 用的是家戶**現在**的場域（歷史事件採集時的場域在 event_docs.site_id_at_capture，之後索引加欄位再改）。
import type { Site } from './planeApi';
import { subtreeIds } from './siteTree';

/** 拆出 site: 的值（支援引號、逗號 = 或），回其餘的查詢字串。 */
export function extractSiteTokens(q: string): { rest: string; values: string[] } {
  const values: string[] = [];
  const item = '(?:"[^"]*"|[^\\s,"]+)';
  const re = new RegExp(`(^|\\s)site:(${item}(?:,${item})*)`, 'gi');
  const rest = q.replace(re, (_m, pre: string, list: string) => {
    for (const m of list.matchAll(/"([^"]*)"|([^\s,"]+)/g)) {
      const t = (m[1] ?? m[2] ?? '').trim();
      if (t) values.push(t);
    }
    return pre;
  });
  return { rest: rest.replace(/\s+/g, ' ').trim(), values };
}

/**
 * site: 值 → 家戶範圍。值可以是場域名稱（不分大小寫、完全相符）或 site_id；每個值連同子場域展開。
 * 回 homes = null 表示查詢裡沒有 site:；unknown = 找不到的值（UI 提示，範圍當成空）。
 */
export function siteScope(values: string[], sites: Site[], homes: { home_id: string; site_id?: string }[]): { homes: string[] | null; unknown: string[] } {
  if (!values.length) return { homes: null, unknown: [] };
  const ids = new Set<string>();
  const unknown: string[] = [];
  for (const v of values) {
    const hits = sites.filter((s) => s.site_id === v || s.name.toLowerCase() === v.toLowerCase());
    if (!hits.length) unknown.push(v);
    for (const s of hits) for (const id of subtreeIds(sites, s.site_id)) ids.add(id);
  }
  return { homes: homes.filter((h) => h.site_id && ids.has(h.site_id)).map((h) => h.home_id), unknown };
}
